import { mediaQuery } from '../enums/mediaQuery';
import useMediaQuery from './useMediaQuery';

export const useDesktop = () => {
  return useMediaQuery(mediaQuery.DESKTOP);
};
